import WebMercatorViewport from "@math.gl/web-mercator";
import { maxBy, minBy } from "lodash";

const getMinOrMax = (markers, minOrMax, latOrLng) => {
  if (minOrMax === "max") {
    return maxBy(markers, value => value[latOrLng])[latOrLng];
  } else {
    return minBy(markers, value => value[latOrLng])[latOrLng];
  }
};

const getBounds = markers => {
  const maxLat = getMinOrMax(markers, "max", "latitude");
  const minLat = getMinOrMax(markers, "min", "latitude");
  const maxLng = getMinOrMax(markers, "max", "longitude");
  const minLng = getMinOrMax(markers, "min", "longitude");

  const southWest = [minLng, minLat];
  const northEast = [maxLng, maxLat];
  const result = [southWest, northEast];
  return result;
};

export const getMapBounds = (viewport, points, width, height) => {
  const MARKERS_BOUNDS = getBounds(points);

  // Use WebMercatorViewport to get center longitude/latitude and zoom
  const newViewport = new WebMercatorViewport({
    width,
    height,
  });
  const bound = newViewport.fitBounds(MARKERS_BOUNDS, {
    padding: 100,
    // offset: [0, -100],
  }); // Can also use option: offset: [0, -100]
  const { longitude, latitude, zoom } = bound;
  return { longitude, latitude, zoom: points.length === 1 ? 14 : zoom - 1 };
};
